import { Mail, MessageSquare, Bot, Phone, Users, Target, Zap } from "lucide-react";

export const mockData = {
  services: [
    {
      id: 1,
      name: "AI Marketing Emails",
      shortName: "Email AI",
      category: "Marketing Automation",
      description: "Advanced AI that crafts personalized email campaigns, analyzes customer behavior patterns, and optimizes send times for maximum engagement and conversion rates.",
      icon: Mail,
      color: "purple",
      image: "https://images.unsplash.com/photo-1750096319146-6310519b5af2",
      features: [
        "Behavioral trigger automation with ML insights",
        "Dynamic content personalization at scale", 
        "Predictive A/B testing optimization",
        "Real-time sentiment analysis & adjustment"
      ]
    },
    {
      id: 2,
      name: "Smart SMS Conversations", 
      shortName: "SMS AI",
      category: "Conversational AI",
      description: "Intelligent SMS agents that understand context, maintain business relevance, and provide instant responses while seamlessly escalating complex queries to human agents.",
      icon: MessageSquare,
      color: "blue",
      image: "https://images.unsplash.com/photo-1675897634504-bf03f1a2a66a",
      features: [
        "Context-aware conversational intelligence",
        "Industry-specific domain expertise",
        "Multi-language natural processing",
        "Intelligent escalation workflows"
      ]
    },
    {
      id: 3,
      name: "Intelligent Chatbot",
      shortName: "Chat AI", 
      category: "Customer Support",
      description: "Next-generation conversational AI with advanced NLP that understands customer intent, provides instant solutions, and creates seamless omnichannel experiences.",
      icon: Bot,
      color: "orange",
      image: "https://images.unsplash.com/photo-1694903089438-bf28d4697d9a",
      features: [
        "Advanced natural language understanding",
        "Intent recognition with 99%+ accuracy",
        "Seamless human handoff integration",
        "24/7 intelligent customer assistance"
      ]
    },
    {
      id: 4,
      name: "Voice Sales Agent",
      shortName: "Voice AI",
      category: "Sales Automation", 
      description: "Human-like AI voice agent that qualifies leads, handles complex sales inquiries, schedules appointments, and integrates directly with your CRM for seamless workflows.",
      icon: Phone,
      color: "pink",
      image: "https://images.unsplash.com/photo-1737644467636-6b0053476bb2",
      features: [
        "Advanced lead qualification algorithms",
        "Intelligent appointment scheduling",
        "CRM integration & pipeline automation",
        "Real-time conversation analytics"
      ]
    }
  ],

  benefits: [
    {
      id: 1,
      title: "Supercharge Efficiency",
      description: "Automate repetitive customer interactions and free your team to focus on strategic initiatives that drive exponential business growth.",
      icon: Zap,
      metric: "400% Productivity Increase"
    },
    {
      id: 2, 
      title: "Maximize Conversions",
      description: "AI-powered personalization and instant response capabilities significantly boost customer engagement and conversion rates across all touchpoints.",
      icon: Target,
      metric: "300% Conversion Boost"
    },
    {
      id: 3,
      title: "Scale Infinitely", 
      description: "Handle unlimited customer interactions simultaneously without increasing headcount, scaling seamlessly from startup to enterprise.",
      icon: Users,
      metric: "Unlimited Scale"
    }
  ],

  faqs: [
    {
      id: 1,
      question: "How quickly can I deploy Let's Optimize AI agents?",
      answer: "After our consultation and custom setup, our AI agents can be deployed within 24-48 hours. Most clients see measurable improvements in customer engagement within the first week of implementation, with full optimization achieved within the first month."
    },
    {
      id: 2,
      question: "Do I need technical expertise to manage the AI systems?",
      answer: "Absolutely not! Our platform is designed for business users with intuitive dashboards, automated optimization, and comprehensive support. Our AI agents learn and improve automatically without requiring technical intervention."
    },
    {
      id: 3,
      question: "How does the CRM integration and data sync work?",
      answer: "Our platform seamlessly integrates with all major CRM systems through secure APIs. Customer registrations automatically become CRM clients, contact inquiries become qualified leads, and all interactions are tracked with detailed analytics and insights."
    },
    {
      id: 4,
      question: "What kind of ROI can I expect from AI implementation?",
      answer: "Our clients typically see 200-400% improvement in engagement rates, 50-80% reduction in response times, and 150-300% increases in conversion rates within the first month. Most see full ROI within 3-6 months depending on implementation scope."
    },
    {
      id: 5,
      question: "How secure is my customer data with your AI platform?",
      answer: "Security is our top priority. We use enterprise-grade encryption, SOC 2 Type II compliance, and adhere to all major data protection regulations including GDPR, CCPA, and HIPAA. Your data never leaves our secure infrastructure."
    }
  ]
};